/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Callout from '../../banners/components/callout';

import styles from '../styles/formCallout.module.scss';

const FormCallout = ({ className = '', fieldId, schema }) => (
  <Callout
    className={classnames(styles.element, className)}
    id={fieldId}
    {...schema}
    textVariant="s02"
  />
);

FormCallout.propTypes = {
  className: PropTypes.string,
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape(Callout.sharedPropTypes).isRequired,
};

export default FormCallout;
